import React, { useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';

import useShowError from '../../../shared/lib/hooks/useShowError';
import { usePostLogisticsResourceImportMutation } from '../../../entities/logistic/logisticTasks/redux/logisticTasks.api';

import Loading from '../../../shared/ui/Loading/Loading';

import FileUploader from './components/FileUplouder/FileUplouder';
import ResultAlert from './components/ResultAlert/ResultAlert';
import SubmitButton from './components/SubmitButton/SubmitButton';
import Container from './styles/Container';
import Wrapper from './styles/Wrapper';

const defaultError = 'Ошибка при обработке файла, попробуйте еще раз';

function CompanyPetrolDeliveryPanel() {
  const [
    postLogisticsImport,
    {
      isLoading: isLoadingPostLogisticsResource,
      isError: isErrorPostLogisticsResource,
      isSuccess: isSuccessPostLogisticsResource,
      data: dataPostLogisticsResource,
      error: errorPostLogisticsResource,
    },
  ] = usePostLogisticsResourceImportMutation();

  const [permanentExel, setPermanentExel] = useState(null);
  const [operationalExel, setOperationalExel] = useState(null);

  const showError = useShowError();
  const navigate = useNavigate();

  const handleFormButtonClick = useCallback(() => {
    if (operationalExel && permanentExel) {
      const formData = new FormData();
      formData.append('permanentFile', permanentExel, permanentExel.name);
      formData.append('operationalFile', operationalExel, operationalExel.name);
      postLogisticsImport({ body: formData, taskType: 'petrol-delivery' });
    } else {
      showError(defaultError);
    }
  }, [postLogisticsImport, permanentExel, operationalExel, showError]);

  useEffect(() => {
    const logisticTaskId = dataPostLogisticsResource?.logisticTaskId;
    if (logisticTaskId) {
      navigate(`/logistics/petrol-delivery/${logisticTaskId}/main`);
    }
  }, [dataPostLogisticsResource, navigate]);

  return (
    <Container>
      <Accordion sx={{ p: 1, width: '100%' }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography sx={{ fontSize: '18px' }}>Перевозка нефтепродуктов</Typography>
        </AccordionSummary>
        <AccordionDetails>
          {isLoadingPostLogisticsResource ? (
            <Loading />
          ) : (
            <Wrapper>
              <FileUploader
                label="Файл с постоянной информацией о СХН, АЗС, бензовозах и т.д (формат XLSX)"
                id="raised-button-file2"
                exelFile={permanentExel}
                setExelFile={setPermanentExel}
              />
              <FileUploader
                label="Файл с оперативными задачами (заявками) (формат XLSX)"
                id="raised-button-file3"
                exelFile={operationalExel}
                setExelFile={setOperationalExel}
              />
              <ResultAlert
                isError={isErrorPostLogisticsResource}
                isSuccess={isSuccessPostLogisticsResource}
                errorData={errorPostLogisticsResource?.data}
              />
              <SubmitButton onClick={handleFormButtonClick} disabled={!permanentExel || !operationalExel} />
            </Wrapper>
          )}
        </AccordionDetails>
      </Accordion>
    </Container>
  );
}

export default CompanyPetrolDeliveryPanel;
